import { TranslationObject } from '../i18n/translation';

const namespace = 'useUnsavedChangesPrompt';
const translations: TranslationObject = {
  message: {
    id: `${namespace}.message`,
    nb: 'Denne siden har ulagrede endringer. Er du sikker på at du vil forlate siden?',
    en: 'This page contains unsaved changes. Are you sure that you want to leave?',
  },
};

export default translations;
